import { jsx as e } from "react/jsx-runtime";
const t = (l) => /* @__PURE__ */ e("svg", { xmlns: "http://www.w3.org/2000/svg", ...l, children: /* @__PURE__ */ e(
  "path",
  {
    fillRule: "evenodd",
    d: "M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm-.706-3.261c.196.174.431.261.706.261.275 0 .51-.087.706-.261A.811.811 0 0 0 11 13.11a.812.812 0 0 0-.294-.628 1.027 1.027 0 0 0-.706-.26c-.275 0-.51.086-.706.26a.812.812 0 0 0-.294.628c0 .245.098.454.294.628ZM9 6v5.333h2V6H9Z",
    clipRule: "evenodd"
  }
) });
export {
  t as IconSmallAttention
};
